<div *ngIf="listing" class="listing-details-wrapper" data-testid="listing-wrapper">
  <div class="row m-0">
    <!-- Gallery Column -->
    <div class="col-12 col-lg-5 p-4" data-testid="listing-gallery-column">
      <div class="gallery-container">
        <dx-gallery #gallery id="gallery" [dataSource]="listing.images" [height]="'100%'" [width]="'100%'" [loop]="true"
          [showNavButtons]="true" [showIndicator]="true" noDataText="No Product Images"
          [elementAttr]="{ 'data-testid': 'listing-gallery' }">
          <div *dxTemplate="let galleryItem of 'item'" class="gallery-item-wrapper">
            <img [src]="galleryItem.url" style="max-width: 100%; max-height: 100%; object-fit: contain"
              (click)="showImage(galleryItem)" />
          </div>
        </dx-gallery>
      </div>
    </div>

    <!-- Info Column -->
    <div class="col-12 col-lg-7 product-info-column" data-testid="listing-info-column">
      <div class="details-grid" data-testid="listing-details-grid">
        <div *ngIf="!hydraEnabled" class="detail-item">
          <span class="detail-label">Supplier:</span>
          <div class="detail-value">
            <app-seller-company-logo [listing]="listing" mode="url"></app-seller-company-logo>
          </div>
        </div>

        <div class="detail-item">
          <span class="detail-label">NDC:</span>
          <div class="detail-value">
            <span class="badge-ndc">{{ listing.ndc | ndc }}</span>
          </div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Details:</span>
          <div class="detail-value">
            <a class="clickable-spec" (click)="openProductSpecs()" data-testid="listing-link-product-specs">
              View Product Specs ->
            </a>
          </div>
        </div>

        <div *ngIf="shippingOption?.description || expedite === 'AcceptAllCharges'" class="detail-item">
          <span class="detail-label">Shipment:</span>
          <div class="detail-value">
            <span
              *ngIf="expedite === 'AcceptAllCharges' && (shippingPrice === 0 || !shippingPrice); else standardShippingDesc"
              class="text-danger" style="font-weight: 500;">
              Expedited
            </span>
            <ng-template #standardShippingDesc>
              {{ shippingPrice ? (shippingPrice | currency: 'USD' : 'symbol') : shippingOption?.description }}
            </ng-template>
          </div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Quantities:</span>
          <div class="detail-value">
            <div class="quantities-list">
              <div class="qty-part" *ngIf="listing.case_size > 1">
                1 Case = {{ listing.case_size }} packs
              </div>
              <div class="qty-part">
                1 Pack = {{ listing.eaches_per_pack }} each(es)
              </div>
              <div class="qty-part">
                1 Each = 1 {{ listing.package_type }}
              </div>
              <div *ngIf="listing.package_description" class="qty-part text-muted" style="font-style: italic">
                {{ listing.package_description | titlecase }}
              </div>
            </div>
          </div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Minimum Order:</span>
          <div class="detail-value">
            {{ listing.min_packs }} pack ({{ listing.min_packs * listing.eaches_per_pack }} eaches)
          </div>
        </div>

        <div *ngIf="listing.hcpcs" class="detail-item">
          <span class="detail-label">HCPCS:</span>
          <div class="detail-value">{{ listing.hcpcs }}</div>
        </div>

        <div *ngIf="relevantAllocation" class="detail-item">
          <span class="detail-label">Allocation Details:</span>
          <div class="detail-value" style="color: #d97706">
            <i class="dx-icon dx-icon-info mr-1"></i>
            {{ allocationMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<dx-popup *ngIf="openProductSpecsPopup" [showTitle]="true" title="Product Specs" [dragEnabled]="true"
  [hideOnOutsideClick]="true" [showCloseButton]="true" (onHiding)="openProductSpecsPopup = false"
  [(visible)]="openProductSpecsPopup" [width]="'min(500px, 95vw)'" height="auto"
  [elementAttr]="{ 'data-testid': 'listing-popup-product-specs' }">
  <div class="product-specs-popup-content">
    <div class="product-info-column p-0">
      <h3 class="product-name">{{ listing.name | uppercase }}</h3>

      <div class="details-grid mt-4">
        <div class="detail-item">
          <span class="detail-label">NDC:</span>
          <div class="detail-value">
            <span class="badge-ndc">{{ listing.ndc | ndc }}</span>
          </div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Classification:</span>
          <div class="detail-value">{{ listing.pharm_class }}</div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Active Ingredient:</span>
          <div class="detail-value">{{ listing.substance_name }}</div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Route:</span>
          <div class="detail-value">{{ listing.route | titlecase }}</div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Storage Conditions:</span>
          <div class="detail-value">{{ listing.storage_conditions }}</div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Sold In Cases:</span>
          <div class="detail-value">{{ listing.case_size > 1 ? 'Yes (' + listing.case_size + ' packs)' : 'No' }}</div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Quantities:</span>
          <div class="detail-value">
            <div class="quantities-list">
              <div class="qty-part">
                1 Pack = {{ listing.eaches_per_pack }} each(es)
              </div>
              <div class="qty-part">
                1 Each = 1 {{ listing.package_type }}
              </div>
            </div>
          </div>
        </div>

        <div class="detail-item">
          <span class="detail-label">Minimum Order:</span>
          <div class="detail-value">
            {{ listing.min_packs }} pack ({{ listing.min_packs * listing.eaches_per_pack }} eaches)
          </div>
        </div>
      </div>
    </div>
  </div>
</dx-popup>

<dx-popup *ngIf="imagePopupVisible" [showTitle]="false" [dragEnabled]="true" width="min(800px, 95vw)" height="auto"
  [hideOnOutsideClick]="true" [showCloseButton]="true" [(visible)]="imagePopupVisible">
  <div class="text-center p-2">
    <img [src]="currentImage?.url" style="max-width: 100%; max-height: 80vh; border-radius: 8px" />
  </div>
</dx-popup>